import React, { FC } from 'react';
import Flatpickr, { DateTimePickerProps } from "react-flatpickr";
import { useTranslation } from 'react-i18next';
import { FormFeedback, Label } from 'reactstrap';
import ErrorMessage from '../ErrorMessage';
import { dateFormat } from '../../../utils/formats';
import { datePickerI18 } from '../../../helpers/functions_helper';

interface DatePickerType extends DateTimePickerProps {
    label?: string;
    placeholder?: string;
    required?: boolean;
    error?: any;
    touched?: any;
    disabled?: boolean;
    sm?: boolean;
}

const DatePicker: FC<DatePickerType> = ({ label, placeholder = "DD/MM/YYYY", required, error, touched, disabled = false, className, sm = false, title = '', ...props }) => {
    const { t } = useTranslation();
    return (
        <>
            {label &&
                <Label className="form-label">
                    {t(label)}
                    {required ? <span className="text-warning is_required ms-1">*</span> : null}
                </Label>
            }

            {/* {disabled ? <input disabled /> : ''} */}

            <Flatpickr
                {...props}
                options={{
                    ...props.options,
                    locale: { ...datePickerI18(), firstDayOfWeek: 1 },
                    // altInput: !disabled,
                    // dateFormat: props.options?.altFormat
                }}
                type="text"
                placeholder={placeholder}
                className={`${className} form-control d-block datepicket`}
                render={(_, ref) => (
                    <div className={`input-group ${sm ? 'input-group-sm' : ''}  ${!!error && touched ? 'is-invalid' : ''}`} title={t(title)}>
                        {/* {JSON.stringify(_)} */}
                        <input
                            type="text"
                            placeholder={placeholder}
                            ref={ref}
                            className={_?.className}
                            id={_?.id}
                            name={_?.name}
                            readOnly
                            disabled={disabled}
                        />
                        {!props.options?.static &&
                            <span className="input-group-text">
                                <span className="align-middle material-symbols-outlined fw-light fs-4">calendar_today</span>
                            </span>
                        }
                    </div>
                )}
            />
            <ErrorMessage error={error} touched={touched} label={label} />
        </>
    )
}

export default DatePicker;